import { create } from 'zustand';
export const useListStore = create((set) => ({
    lists: [],
    currentListId: null,
    items: {},
    setLists: (lists) => set({ lists }),
    addList: (list) => set((state) => ({
        lists: [...state.lists, list],
    })),
    updateList: (id, updates) => set((state) => ({
        lists: state.lists.map((list) => list.id === id ? { ...list, ...updates } : list),
    })),
    removeList: (id) => set((state) => ({
        lists: state.lists.filter((list) => list.id !== id),
        items: Object.fromEntries(Object.entries(state.items).filter(([key]) => Number(key) !== id)),
        currentListId: state.currentListId === id ? null : state.currentListId,
    })),
    setCurrentList: (id) => set({ currentListId: id }),
    setItems: (listId, items) => set((state) => ({
        items: { ...state.items, [listId]: items },
    })),
    addItem: (listId, item) => set((state) => ({
        items: {
            ...state.items,
            [listId]: [...(state.items[listId] || []), item],
        },
    })),
    updateItem: (listId, itemId, updates) => set((state) => ({
        items: {
            ...state.items,
            [listId]: (state.items[listId] || []).map((item) => item.id === itemId ? { ...item, ...updates } : item),
        },
    })),
    removeItem: (listId, itemId) => set((state) => ({
        items: {
            ...state.items,
            [listId]: (state.items[listId] || []).filter((item) => item.id !== itemId),
        },
    })),
    reorderItems: (listId, items) => set((state) => ({
        items: { ...state.items, [listId]: items },
    })),
}));
